import { useState, useRef, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './FortuneWheelContent.module.scss';
import WheelComponent from './WheelComponent.tsx';
// import { getSpinInfo } from '../../Services/Requests.ts';
import { useNotificationStore } from '../../store/NotificationStore.ts';
import { getSpinInfo, getWheelTasks } from '@/api/modules/Wheel/wheel';
import WheelTaskItem from './WheelTaskItem.tsx';
import { Loader } from '@/components/Loader/Loader';

import confetti from 'canvas-confetti';

interface WheelRef {
  isInitialized: () => boolean;
  spin: (targetIndex: number) => void;
}

const PRIZES = [
  { amount: '10', type: 'STARS' },
  { amount: '0.3', type: 'STARS' },
  { amount: '0.5', type: 'STARS' },
  { amount: '1', type: 'STARS' },
  { amount: '2', type: 'STARS' },
  { amount: '5', type: 'STARS' },
];

export function ConfettiStars() {
  const handleClick = () => {
    const defaults = {
      spread: 360,
      ticks: 50,
      gravity: 0,
      decay: 0.94,
      startVelocity: 30,
      colors: ['#FFE400', '#FFBD00', '#E89400', '#FFCA6C', '#FDFFB8'],
    };

    const shoot = () => {
      confetti({
        ...defaults,
        particleCount: 40,
        scalar: 1.2,
        shapes: ['star'],
      });

      confetti({
        ...defaults,
        particleCount: 10,
        scalar: 0.75,
        shapes: ['circle'],
      });
    };

    setTimeout(shoot, 0);
    setTimeout(shoot, 100);
    setTimeout(shoot, 200);
  };
}

const FortuneWheel = () => {
  const [isSpinning, setIsSpinning] = useState(false);
  const [isButtonEnabled, setIsButtonEnabled] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [currentPrize, setCurrentPrize] = useState<any>(null);
  const wheelRef = useRef<WheelRef>(null);
  const navigate = useNavigate();
  const [wheelTasks, setWheelTasks] = useState<any>([]);
  const [tasksLoaded, setTasksLoaded] = useState(false);

  const fetchWheelTasks = async () => {
    try {
      const tasks = await getWheelTasks();
      setWheelTasks(tasks);
      setTasksLoaded(true);
      console.log(tasks);
    } catch (error) {
      console.error('Ошибка загрузки заданий:', error);
      setTasksLoaded(true); // Все равно скрываем лоадер
    }
  };

  useEffect(() => {
    fetchWheelTasks();
  }, []);

  const setNotification = useNotificationStore(
    (state) => state.setNotification,
  );

  const tg = window?.Telegram?.WebApp;
  const [isWheelInitialized, setIsWheelInitialized] = useState(false);

  const findSectorIndex = useCallback(
    (targetValue: any, targetCurrency: any) =>
      PRIZES.findIndex(
        (prize) =>
          prize.amount === String(targetValue) && prize.type === targetCurrency,
      ),
    [],
  );

  const handleSpinResult = useCallback((resultIndex: any) => {
    console.log('Вращение началось, целевой индекс:', resultIndex);
  }, []);
  const isDone = wheelTasks?.tasks?.every(
    (task: any) => task.status === 'claim',
  );
  const handleSpinComplete = useCallback(
    (resultIndex: any) => {
      setIsSpinning(false);
      const prize = PRIZES[resultIndex];
      console.log(prize);
      setCurrentPrize(prize);

      // 🎉 Конфетти
      const defaults = {
        spread: 360,
        ticks: 50,
        gravity: 0,
        decay: 0.94,
        startVelocity: 30,
        colors: ['#FFE400', '#FFBD00', '#E89400', '#FFCA6C', '#FDFFB8'],
      };

      const shoot = () => {
        confetti({
          ...defaults,
          particleCount: 40,
          scalar: 1.2,
          shapes: ['star'],
        });

        confetti({
          ...defaults,
          particleCount: 10,
          scalar: 0.75,
          shapes: ['circle'],
        });
      };

      setTimeout(shoot, 0);
      setTimeout(shoot, 100);
      setTimeout(shoot, 200);

      setNotification({
        type: 'Success',
        message: `Поздравляем! Ты выиграл:`,
        rewards: [{ amount: Number(prize.amount), type: prize.type }],
      });
    },
    [setNotification],
  );

  const handleSpinClick = useCallback(async () => {
    if (isSpinning) return;

    if (!wheelRef.current?.isInitialized()) {
      console.warn('Колесо еще не инициализировано');
      return;
    }
    const isDone = wheelTasks?.tasks?.every(
      (task: any) => task.status === 'claim',
    );
    console.log(wheelTasks);
    if (!isDone) {
      console.log(isDone);
      setNotification({
        type: 'Warning',
        message: 'Выполни все задания для прокрутки!',
      });
      return;
    }

    try {
      setIsLoading(true);
      const response = await getSpinInfo();
      console.log(response);
      if (response?.amount) {
        const targetIndex = findSectorIndex(
          String(response.amount),
          response.type,
        );

        if (targetIndex !== -1) {
          wheelRef.current.spin(targetIndex);
          setIsSpinning(true);
          fetchWheelTasks();
        } else {
          throw new Error('Сектор не найден');
        }
      }
    } catch (error) {
      console.error('Ошибка при вращении:', error);
      setIsSpinning(false);
    } finally {
      setIsLoading(false);
    }
  }, [isSpinning, findSectorIndex, wheelTasks, setNotification]);

  const handleWheelInitialized = useCallback(() => {
    setIsWheelInitialized(true);
    setTimeout(() => {
      setIsButtonEnabled(true);
      setIsLoading(false);
    }, 600);
  }, []);

  // Показываем лоадер пока задания не загружены
  if (!tasksLoaded) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '50vh',
        }}
      >
        <Loader />
      </div>
    );
  }

  return (
    <div className={styles.fortuneWheelContainer}>
      <div className={styles.header}>
        <h1 className={styles.title}>Колесо Фортуны</h1>
        <p className={styles.description}>
          Выполняй задания и вращай колесо фортуны. <br /> Награды начисляются
          сразу после прокрута.
        </p>
      </div>

      <WheelComponent
        onSpin={handleSpinResult}
        onSpinComplete={handleSpinComplete}
        onInitialized={handleWheelInitialized}
        ref={wheelRef}
      />

      {!isDone ? (
        <button
          onClick={handleSpinClick}
          disabled={isSpinning}
          className={styles.spinButtonNotDone}
        >
          Крутить колесо!
        </button>
      ) : (
        <button
          onClick={handleSpinClick}
          disabled={isSpinning}
          className={styles.spinButton}
        >
          Крутить колесо!
        </button>
      )}

      <div className={styles.tasksContainer}>
        {wheelTasks?.tasks?.map((task: any) => (
          <WheelTaskItem key={task.id} task={task} />
        ))}
      </div>
    </div>
  );
};

export default FortuneWheel;
